import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  Button,
  PrimaryButton,
} from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface AccountTypeProps {
  orgName: string;
  onClickWorkAndOthers: () => void;
  onClickNotWork: () => void;
  onDismiss: () => void;
  image?: HTMLImageElement;
}

export const AccountType: FunctionComponent<AccountTypeProps> = ({
  image,
  orgName,
  onClickWorkAndOthers,
  onClickNotWork,
  onDismiss,
}) => (
  <OnboardingDialog
    closeDialog={onDismiss}
    title={format('tell us more')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    image={image}
  >
    <div>{format('what do you use it for', { org: orgName })}</div>
    <div className={styles.section}>
      <PrimaryButton onClick={() => onClickWorkAndOthers()}>
        {format('use for org and other button', {
          org: orgName,
        })}
      </PrimaryButton>
    </div>
    <div className={styles.item}>
      <Button onClick={() => onClickNotWork()}>
        {format('dont use for org button', {
          org: orgName,
        })}
      </Button>
    </div>
  </OnboardingDialog>
);
